export const candidateQ1 =
    '1) Have you read the CSIRO "Donnelly River Model Review" by Justin Hughes released 31/05/2021?';
export const candidateQ2 = '2) Do you oppose an SFIS style water scheme?';
export const candidateQ3 = '3) Do you oppose a water trading market in principle?';
